import profileScreenshot from "../assets/ss-1.jpg";
import openAccountScreenshot from "../assets/ss-2.jpg";

const steps = [
  {
    title: "1. Daftar Akun Broker VT Market",
    desc: "Untuk bisa masuk Premium, wajib daftar akun broker melalui link resmi Arfa FX agar otomatis terdata under IB",
  },
  {
    title: "2. Sudah Punya Akun VT Market?",
    desc: "Hubungi admin kami untuk proses pemindahan IB ke Arfa FX.",
  },
  {
    title: "3. Setelah Under IB Arfa FX",
    desc: "Pilih STANDARD STP (MetaTrader 5) untuk bisa bergabung ke Premium Arfa FX.",
  },
];

const RegistrationGuidePage = () => {
  return (
    <section className="min-h-[70vh] bg-gradient-to-b from-[#0f0018] via-[#07000d] to-[#020103] px-6 py-24">
      <div className="mx-auto max-w-5xl space-y-10">
        <div className="text-center">
          <p className="inline-flex rounded-full border border-white/15 px-4 py-1 text-xs uppercase tracking-[0.4em] text-[#ff9dff]">
            Panduan Registrasi
          </p>
          <h1 className="mt-6 text-4xl font-black text-white">Cara Registrasi ArfaFX Premiun</h1>
          <p className="mt-4 text-white/70">
            Ikuti langkah berikut untuk mengaktifkan akun trading dan menikmati seluruh fasilitas
            komunitas kami.
          </p>
        </div>

        <div className="mt-10 rounded-3xl border border-white/10 bg-gradient-to-br from-[#140021] via-[#070010] to-[#020005] p-8 text-white shadow-[0_30px_80px_rgba(0,0,0,0.65)]">
          <div className="mx-auto max-w-3xl space-y-6">
            <div className="space-y-2 text-center">
              <h3 className="text-2xl sm:text-2xl font-black">
              💎 Benefit VIP Group Arfa FX 💎
              </h3>
              <ul className="mt-2 space-y-1 list-disc list-inside">
                  <li>Setup forex dengan akurasi tinggi.</li>
                  <li>Analisa market harian (Forex &amp; Gold).</li>
                  <li>Update news fundamental penting (NFP, CPI, FOMC, dll).</li>
                  <li>Edukasi berupa materi video dan webinar rutin.</li>
                  <li>Private discussion &amp; mentoring langsung dengan mentor.</li>
                  <li>Update video entry lengkap beserta reason-nya.</li>
                </ul>
            </div>  
          </div>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <div
              key={step.title}
              className={`rounded-3xl border border-white/10 bg-white/5 p-6 text-white shadow-[0_25px_60px_rgba(0,0,0,0.25)]`}
            >
              <h3 className="text-2xl font-bold text-white">{step.title}</h3>
              <p className="mt-3 text-sm text-white/70">{step.desc}</p>

              {index === 0 && (
                <div className="mt-6 rounded-2xl border border-white/10 bg-gradient-to-br from-[#1a0a2e] to-[#0f0519] p-6">
                  <h4 className="text-lg font-bold text-white mb-6">Link Registrasi Akun</h4>

                  <div className="space-y-6">
                    <div className="space-y-2">
                      <p className="text-white font-semibold text-sm">Prosesnya Cepat & Gratis!</p>
                      <ol className="space-y-2 text-white/80 text-sm list-decimal list-inside">
                        <li>Isi data diri</li>
                        <li>Verifikasi email</li>
                        <li>Upload KTP & bukti alamat</li>
                        <li>Tunggu akun aktif</li>
                      </ol>
                      <a
                        href="https://www.vtmarketsgroupid.com/trade-now/?affid=MjIzOTYxMzM=&invitecode=ARFAFX15"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex rounded-full bg-gradient-to-r from-[#ff00bf] to-[#ff7aec] px-6 py-2.5 text-sm font-semibold text-white shadow-[0_15px_40px_rgba(255,0,191,0.45)] hover:scale-[1.02] transition-transform"
                      >
                        Daftar
                      </a>
                    </div>
                  </div>

                  <div className="mt-6 pt-6 border-t border-white/10">
                    <h4 className="text-lg font-bold text-white mb-6">Channel Telegram Tutorial Bergabung Premium</h4>
                    <a
                      href="https://t.me/joinpremiumarfafx/23"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex w-full justify-center rounded-full bg-gradient-to-r from-[#ff00bf] to-[#ff7aec] px-6 py-3 text-sm font-semibold text-white shadow-[0_15px_40px_rgba(255,0,191,0.45)] hover:scale-[1.02] transition-transform"
                    >
                      Selengkapnya
                    </a>
                  </div>
                </div>
              )}

              {index === 1 && (
                <div className="mt-6 rounded-2xl border border-white/10 bg-gradient-to-br from-[#1a0a2e] to-[#0f0519] p-6">
                  <div className="mt-2 overflow-hidden rounded-2xl border border-white/10 bg-black/40">
                    <img
                      src={profileScreenshot}
                      alt="Contoh tampilan profil akun VT Market"
                      className="h-full w-full object-cover"
                    />
                  </div>

                  <div className="space-y-3 text-sm text-white/80 mt-4">
                    <p>
                      Jika sudah memiliki akun sebelumnya dan belum under IB Arfa FX, silakan hubungi{" "}
                      <span className="font-semibold text-white"> <a href="https://t.me/arfa_fx" target="_blank" rel="noopener noreferrer" className="text-[#ff9dff] hover:text-[#ff00bf] hover:underline">@arfa_fx</a></span>.
                    </p>
                    <div>
                      <p className="font-semibold text-white">Kirimkan ke admin:</p>
                      <ul className="mt-1 list-disc list-inside space-y-1">
                        <li>UID akun trading</li>
                        <li>Email yang terdaftar</li>
                      </ul>
                    </div>
                    <p>
                      Admin akan bantu proses pengecekan & pengajuan pemindahan IB ke Arfa FX sesuai
                      ketentuan broker.
                    </p>
                    <p className="text-xs text-white/60">
                      (Pastikan kamu menyetujui kebijakan broker yang berlaku.)
                    </p>
                  </div>

                  <a
                    href="https://t.me/arfa_fx"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-4 inline-flex rounded-full bg-gradient-to-r from-[#ff00bf] to-[#ff7aec] px-6 py-3 text-sm font-semibold text-white shadow-[0_15px_40px_rgba(255,0,191,0.45)] hover:scale-[1.02] transition-transform"
                  >
                    Hubungi Admin
                  </a>
                </div>
              )}

              {index === 2 && (
                <div className="mt-6 rounded-2xl border border-white/10 bg-gradient-to-br from-[#1a0a2e] to-[#0f0519] p-6">

                  <div className="mt-2 overflow-hidden rounded-2xl border border-white/10 bg-black/40">
                    <img
                      src={openAccountScreenshot}
                      alt="Contoh pilihan akun STANDARD STP MetaTrader 5"
                      className="h-full w-full object-cover"
                    />
                  </div>

                  <div className="space-y-3 text-sm text-white/80 mt-4">
                    <p>
                      Jika sudah under IB Arfa FX, silakan buka akun trading{" "}
                      <span className="font-semibold text-white">
                        STANDARD STP (MetaTrader 5)
                      </span>{" "}
                      lalu lakukan deposit minimal{" "}
                      <span className="font-semibold text-white">Rp500.000</span> atau{" "}
                      <span className="font-semibold text-white">$30</span> untuk bisa bergabung ke Premium
                      Arfa FX.
                    </p>
                    <div>
                      <p className="font-semibold text-white">Setelah membuat akun, wajib kirim:</p>
                      <ul className="mt-1 list-disc list-inside space-y-1">
                        <li>Screenshot ID akun trading</li>
                        <li>Screenshot bukti sudah terdaftar under IB Arfa FX</li>
                        <li>Screenshot bukti deposit</li>
                      </ul>
                    </div>
                    <p>
                      Kirim semua bukti ke admin untuk proses verifikasi. Deposit hanya dilakukan setelah
                      akun dipastikan sudah benar (STANDARD STP & under IB Arfa FX).
                    </p>
                    <div className="mt-4 p-3 rounded-lg border border-yellow-500/30 bg-yellow-500/10">
                      <p className="text-sm text-yellow-300 flex items-start gap-1">
                        <span>⚠</span>
                        <span>
                          Akun yang tidak terdaftar under IB Arfa FX tidak bisa masuk ke grup Premium.
                        </span>
                      </p>
                    </div>

                  </div>

                  <a
                    href="https://t.me/arfa_fx"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-4 inline-flex rounded-full bg-gradient-to-r from-[#ff00bf] to-[#ff7aec] px-6 py-3 text-sm font-semibold text-white shadow-[0_15px_40px_rgba(255,0,191,0.45)] hover:scale-[1.02] transition-transform"
                  >
                    Hubungi Admin
                  </a>
                </div>
              )}

            </div>
          ))}
        </div>
        <div className="mt-10 rounded-3xl border border-white/10 bg-gradient-to-r from-[#ff00bf] to-[#ff7aec] p-10 text-black shadow-[0_30px_80px_rgba(255,0,191,0.35)]">
          <div className="max-w-2xl mx-auto text-center">
            <h3 className="text-3xl font-black mb-4">Butuh Bantuan?</h3>
            <p className="text-lg font-semibold text-black/80 mb-6 leading-relaxed">
              Silahkan hubungi admin kami untuk bantuan lebih lanjut. Tim support kami siap membantu 24/7 melalui WhatsApp.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="https://t.me/arfa_fx"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center rounded-full bg-black px-8 py-4 text-base font-semibold text-white shadow-[0_15px_40px_rgba(0,0,0,0.3)] hover:scale-[1.1] transition-transform min-w-[200px]"
              >
                <span className="mr-2">💬</span>
                Hubungi Admin
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegistrationGuidePage;

